export default {
  versionName: 'Munster Athletics Production Portal',
  versionNumber: '1.0.0',
  baseUrl: 'http://munsterathletics.com',
  apiUrl: 'http://munsterathletics.com/munster/v1',
}